import { trackAmazonTagEvent, AmazonTagEvent } from './trackAmazonTagEvent';

/**
 * track an Amazon page view event
 */
export function trackAmazonTagPageView(): void {
  trackAmazonTagEvent({ name: AmazonTagEvent.PageView });
}
